import Loader from '../loader/loader.js';
import "./paymentManager.scss";
import EventManager from "../eventManager.js";
import MessageBoxManager from "../messageBox/messageBoxManager.js";
import StringUtils from "../utils/string.js";

export default class PaymentManager extends EventManager {

    constructor (options) {

        super();

        this.settings = $.extend({}, {
            reloadTimeout: 5,
            globalLoader: null
        }, options);

        this.$container = $('#block_payment');

        this.loader = new Loader(this.$container);

        this.$actionsBar = $('<div/>', { class: 'actions-bar' })
            .insertAfter(this.$container);

        this.$costSummaryContainer = $('<div/>', { class: 'cost-summary' })
            .appendTo(this.$container);

        this.$infoContainer = $('<div/>', { class: 'infos' })
            .appendTo(this.$container);

        this.$cardsContainer = $('<div/>', { class: 'cards' })
            .appendTo(this.$container);

        this.$modesContainer = $('<div/>', { class: 'modes' })
            .appendTo(this.$container);

        this.messageBoxManager = new MessageBoxManager(
                this.$container.closest('.contenu').children('.stacked-rounded-list'),
                {
                    method: 'insertAfter',
                    extraClasses: 'message-box'
                }
            );

        this.unvalidate();
    }

    info(message, options) {

        let settings = $.extend({}, {
                type: 'info'
            }, options);

        let icon = 'info-circle';

        switch (settings.type) {
            case 'error': icon = 'exclamation-triangle'; break;
        }

        this.$infoContainer.append(`
                <div class="${settings.type}">
                    <div class="icon">
                        <i class="fa fa-${icon}" aria-hidden="true"></i>
                    </div>
                    ${message}
                </div>
            `);

    }

    getCost () {
        return new Promise( (resolve, reject) => {
            $.post("core/ajax/ajax_panier.php", {
                action: "total",
                _format: 'json'
            })
            .done(resolve)
            .fail(reject);
        });
    }

    reset () {
        this.$costSummaryContainer.empty();
        this.$infoContainer.empty();
        this.$cardsContainer.empty();
        this.$modesContainer.empty();
        this.$costSummaryContainer.html('<p class="not-ready">Vous devez valider votre mode de livraison avant tout ;-)</p>');
    }

    update () {
        this.messageBoxManager.clearNotifications();
        let tid = this.loader.startTask();

        $.post("core/ajax/ajax_panier.php", {
            action: "paiement",
            _format: 'json'
        }).done(answer => {
            // getting the list of avaible payment modes
            this.messageBoxManager.clearNotifications();

            this.reset();
            this.$costSummaryContainer.empty();
            this.getCost().then( details => this.$costSummaryContainer.html( `

                <span class="total-products">Total produits : ${StringUtils.toLocaleString(details.total_products, {style: 'currency', currency: 'EUR'})}</span>
                ${details.savings > 0 ? `<br/><span class="shipping">Réduction : -${StringUtils.toLocaleString(details.savings, {style: 'currency', currency: 'EUR'})}</span>` : ''}
                <br/><span class="shipping">Frais d'expédition : ${details.shipping > 0 ? `${StringUtils.toLocaleString(details.shipping, {style: 'currency', currency: 'EUR'})}` : 'Gratuit'}</span>
                <hr/><span class="total">Total à payer : ${StringUtils.toLocaleString(details.total, {style: 'currency', currency: 'EUR'})}</span>
            ` ) ).catch(data => {
                this.messageBoxManager.notifyUnexpectedError();
            });

            this.$container.show();

            if (answer.modes == undefined) {
                this.messageBoxManager.notifyUnexpectedError();
                return;
            }

            if (answer.modes.length == 0) {
                this.info( `
                    <p>Nous sommes désolés mais nous ne pouvons vous proposer de moyens de paiement par rapport à votre pays de facturation.</p>
                    <p>Votre commande ne peut pas être enregistrée !</p>
                    <p>Vous pouvez contacter notre service client pour obtenir plus de renseignements.</p>`,
                    { type: 'error' });

            } else {

                // update cards list
                // answer.cards = [
                //     {identifier: "AELbxLb+dRhx4ZVYeIyPLvHGUQ3zA0EuBFBzx46DkTQ=", card_number: "497010XXXXXX0000", card_month: "6", card_year: "2018", card_type: "CB"},
                //     {identifier: "WZ1rFvlrW+f6Zr5Or8FoI0Q9DxW+sIpcHw0lSYdR76w=", card_number: "497010XXXXXX0000", card_month: "6", card_year: "2018", card_type: "CB"}
                // ];

                if (answer.cards.length) {

                    this.$cardsContainer.append(`
                        <table>
                            <thead>
                                <tr><th colspan="50"><i class="fa fa-caret-right" aria-hidden="true"></i> Vos cartes enregistrées</th></tr>
                            </thead>
                            <tbody></tbody>
                        </table>
                    `);
                    this.$cardslistContainer = this.$cardsContainer.find('> table > tbody');

                    for (let card of answer.cards) {
                        $(`<tr data-id=${card.identifier}>
                                <td><img class="logo" src="images/interface/default/paiement/carte/${card.card_type}.png" /></td>
                                <td>
                                    <p class="description">
                                        <span>N&deg;&nbsp;:&nbsp;${card.card_number},</span>
                                        <span>Expire le : ${card.card_month}/${card.card_year}</span>
                                    </p>
                                </td>
                            </tr>`)
                                .appendTo(this.$cardslistContainer)
                                .click(this.checkout.bind(this, null, card.identifier));
                    }
                }

                // update modes list
                if (answer.modes.length) {

                    this.$modesContainer.append(`
                        <table>
                            ${ answer.modes.length > 1
                                ? `<thead>
                                    <tr><th colspan="50"><i class="fa fa-caret-right" aria-hidden="true"></i> ${answer.cards.length == 0 ? 'Vos' : 'Autres'} modes de paiement</th></tr>
                                </thead>`
                                : '' }
                            
                            <tbody></tbody>
                        </table>
                    `);

                    this.$modeslistContainer = this.$modesContainer.find('> table > tbody');

                    for (let mode of answer.modes) {
                        let payment = $(`<tr data-id=${mode.id}>
                            <td><img class="logo" src="images/interface/default/paiement/${mode.img_grande}" /></td>
                            <td>
                                <p class="description">${mode.descriptif}</p>
                                <p class="extra-info-virement">${mode.id == 3 ? 'Attention nouveau RIB Bébé au Naturel' : ''}</p>
                                    ${mode.options && mode.options.extra_description
                          ? `<p class="extra-info ${mode.options.saveCard ? 'important' : ''}">${mode.options.extra_description}</p>`
                          : ''
                        }
                            </td>
                        </tr>`)
                          .appendTo(this.$modeslistContainer)
                          .click(this.checkout.bind(this, mode, null));
                        payment.click(e => {
                            const shipping = document.querySelector('.contenu.adresses')
                            shipping.classList.add('payment-selected')
                            shipping.setAttribute('data-payment', mode.id)
                            window.dispatchEvent(new Event('selectPayment'))
                        })
                    }
                }

            }

        }).fail(data => {
            this.messageBoxManager.notifyUnexpectedError();
        }).always(() => this.loader.stopTask(tid));

    }

    unvalidate () {
        this.reset();
    }

    checkout(mode, cardId = '') {

        if (cardId != null && cardId != '' && mode == null) {
            mode = {
                id: '2',
                options: { saveCard: true }
            };
        }

        this.settings.globalLoader.configure({delay: 0});
        let checkout_load_task_id = this.settings.globalLoader.startTask();

        this.messageBoxManager.clearNotifications();

        super.on('validate', mode, cardId);

        $.post("core/ajax/ajax_panier.php", {
            action: 'check_livraison',
            _format: 'json'
        }).done( json => {

            if (json.result == true) {
                this.settings.globalLoader.configure({delay: 0});
                let checkout_action_task_id = this.settings.globalLoader.startTask();

                switch (mode.id) {

                    // CB checkout
                    case '2' :
                        $.post("core/paiement/appel_bouton_paiement.php", {
                            identifier: cardId == null ? '' : cardId,
                            register: (mode.options && mode.options.saveCard ? '1' : '0'),
                            browser_infos_java_enabled: navigator.javaEnabled(),
                            browser_infos_javascript_enabled: true,
                            browser_infos_language: navigator.language,
                            browser_infos_color_depth: window.screen.colorDepth,
                            browser_infos_screen_height: window.screen.height,
                            browser_infos_screen_width: window.screen.width,
                            browser_infos_timezone: (new Date()).getTimezoneOffset(),
                            browser_infos_http_user_agent: navigator.userAgent,
                            _format: 'json'
                        }).done(answer => {

                            if (answer.type == undefined) {
                                this.settings.globalLoader.stopTask(checkout_action_task_id);
                                this.settings.globalLoader.configure({delay: 500});

                                this.messageBoxManager.notifyUnexpectedError();
                                return;
                            }

                            if (answer.type == 'form') {
                                $(answer.data.message).appendTo(this.$container).hide();
                                $('#form_bank').submit();
                            } else if (answer.type == 'link') {
                                window.location.href = answer.data.message;
                            } else {
                                if (answer.type == 'error') {
                                    popup.info(answer.data.message + '<br/>La page va se recharger automatiquement...', {type: 'error'});

                                    if (answer.data.reload || answer.data.redirect !== null) {
                                        setTimeout(() => {
                                            if (answer.data.redirect !== null) {
                                                window.location.href = answer.data.redirect;
                                            } else {
                                                window.location.reload();
                                            }
                                        }, this.settings.reloadTimeout * 1000);
                                    } else {
                                        this.settings.globalLoader.stopTask(checkout_action_task_id);
                                        this.settings.globalLoader.configure({delay: 500});

                                    }
                                }
                            }
                        }).fail(error => {
                            this.settings.globalLoader.stopTask(checkout_action_task_id);
                            this.settings.globalLoader.configure({delay: 500});

                            this.messageBoxManager.notifyUnexpectedError();
                        });
                        break;

                    // All other checkout types
                    default:
                        window.location.href = mode.lien;
                        break;
                }

            } else {
                popup.info('La page va se recharger automatiquement...', {type: 'error'});

                setTimeout(() => {
                    window.location.reload();
                }, this.settings.reloadTimeout * 1000);

            }

        }).fail(data => {
            this.messageBoxManager.notifyUnexpectedError();
        }).always( () => {
            this.settings.globalLoader.stopTask(checkout_load_task_id);
            this.settings.globalLoader.configure({delay: 500});

        });
    }

}
